import TextCheckButton from 'components/common/button/TextCheckButton';
import UnitSlider from 'components/common/slider/UnitSlider';
import CustomText from 'components/common/text/CustomText';
import { indicationOptionList } from 'lib/mapper';
import React, { useMemo } from 'react';
import styled from 'styled-components';

interface AdvancedOptionProps {
  advancedOption: {
    inputs: {
      [key: string]: any;
    };
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
  advancedValue: {
    inputs: {
      [key: string]: any;
    };
    onChange: (event: any) => void;
    setInputs: React.Dispatch<React.SetStateAction<{}>>;
    onReset: () => void;
  };
}

function AdvancedOption({ advancedOption, advancedValue }: AdvancedOptionProps) {
  return (
    <StyledBasicOption>
      <div className="advancedOption__select_option">
        {useMemo(() => {
          return indicationOptionList.advanced.map((option: any, index: number) => {
            if (!advancedOption?.inputs || !advancedValue?.inputs) return;

            const optionItem = advancedOption?.inputs[option.key];
            const optionValue = advancedValue?.inputs[option.key];

            if (!!optionItem) {
              return option.type === 'slider' ? (
                <div className="advancedOption__item_box" key={index}>
                  <div className="slider_option">
                    <CustomText
                      fontSize={13}
                      fontWeight={400}
                      fontColor="#444"
                      className="slider_option_label"
                    >
                      {option.title}
                    </CustomText>
                    <UnitSlider
                      ariaLabelledby={`${option.key}-slider`}
                      data={optionValue || 0}
                      min={optionItem?.minValue}
                      max={optionItem?.maxValue}
                      onValueChange={newVal => {
                        advancedValue.setInputs({
                          ...advancedValue.inputs,
                          [option.key]: newVal,
                        });
                      }}
                      step={optionItem?.stepSize}
                      digit={6}
                    />
                  </div>
                </div>
              ) : (
                <div className="advancedOption__item_box">
                  <div className="radio_option">
                    <div className="radio_option_item">
                      <CustomText
                        className="option_title"
                        fontSize={13}
                        fontColor="#444"
                        fontWeight={400}
                      >
                        {option.title}
                      </CustomText>

                      {optionItem.values.map((valueItem: any, index: number) => (
                        <TextCheckButton
                          className="form__text_check_btn"
                          active={optionValue === valueItem?.value}
                          width="148px"
                          padding="0 10px"
                          minHeight="30px"
                          key={index}
                          onClick={() => {
                            advancedValue.setInputs({
                              ...advancedValue.inputs,
                              [option.key]: valueItem?.value,
                            });
                          }}
                        >
                          <CustomText fontSize={13} fontWeight={400} className="option_description">
                            {valueItem?.description}
                          </CustomText>
                        </TextCheckButton>
                      ))}
                    </div>
                  </div>
                </div>
              );
            }
          });
        }, [advancedOption, advancedValue])}
      </div>
    </StyledBasicOption>
  );
}

const StyledBasicOption = styled.div`
  padding: 20px;
  overflow: auto;
  .advancedOption__select_option {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .advancedOption__item_box {
      .radio_option {
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        .radio_option_item {
          display: flex;
          align-items: center;
          .option_title {
            width: 173px;
            flex-shrink: 0;
            word-wrap: break-word;
          }
          .option_description {
            text-align: center;
          }
        }
      }
      .slider_box {
        display: flex;
        flex-direction: column;
        row-gap: 5px;
        .slider_option {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          /* margin-top: 15px;
              padding: 8px 0; */
          .slider_option_label {
            width: 100%;
            /* margin-bottom: 5px; */
          }
        }
      }
    }
  }
`;

export default AdvancedOption;
